import * as React from "react";
import styled from "styled-components";

import { truncateLine } from "../../common/utils/style";
import ImageComponent, { Image } from "../../common/components/Image";

type Company = WtdModels.Partial<
  WtdModels.Company,
  "company_path" | "name" | "short_location" | "mission_statement",
  {
    avatar: WtdModels.HasOne<Image>;
  }
>;

export interface CompanyCardLateralModels {
  Company: Company;
}

interface Props {
  className?: string;
  company: Company;
}

const CompanyCardLateral: React.SFC<Props> = props => {
  const { company } = props;

  return (
    <Base href={company.company_path} className={props.className}>
      <AvatarWrapper>
        {company.avatar && <Avatar image={company.avatar} size="57x57#" alt={company.name} />}
      </AvatarWrapper>
      <Meta>
        <Name>{company.name}</Name>
        {company.short_location && (
          <Location>
            <LocationIcon className="wt-icon wt-icon-location" />
            {company.short_location}
          </Location>
        )}
        {company.mission_statement && <TagLine>{company.mission_statement}</TagLine>}
      </Meta>
    </Base>
  );
};

const Base = styled.a`
  display: flex;
  width: 100%;
  &:hover {
    text-decoration: none;
  }
`;

const AvatarWrapper = styled.div`
  flex-shrink: 0;
  width: 57px;
  height: 57px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #bbb;
  margin-right: 10px;
`;

const Avatar = styled(ImageComponent)`
  width: 100%;
  height: 100%;
  border: solid 1px #ffffff;
  box-sizing: border-box;
`;

const Meta = styled.div`
  width: calc(100% - 67px);
  margin-left: 10px;
`;

const Name = styled.div`
  font-weight: 600;
  font-size: 15px;
  line-height: 1.2;
  color: rgba(0, 0, 0, 0.8);
  margin-bottom: 7px;
`;

const Location = styled.div`
  display: flex;
  font-weight: 400;
  font-size: 12px;
  line-height: 1;
  color: rgba(0, 0, 0, 0.56);
`;

const LocationIcon = styled.i`
  margin-top: -2px;
  margin-right: 5px;
`;

const TagLine = styled.div`
  font-weight: 600;
  font-size: 12px;
  margin-top: 6px;
  line-height: 1.2;
  color: rgba(0, 0, 0, 0.56);
  ${truncateLine};
`;

export default CompanyCardLateral;



// WEBPACK FOOTER //
// ./frontend/src/companies/components/CompanyCardLateral.tsx